const replaceAtIdx = (arr, el, idx) => [
    ...arr.slice(0, idx),
    el,
    ...arr.slice(idx + 1, arr.length)
];
export default replaceAtIdx;
//# sourceMappingURL=index.js.map